import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;
    this.options = {
      speed: 600,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: this.element.querySelector('.swiper-button-next'),
        prevEl: this.element.querySelector('.swiper-button-prev'),
      },
    };
    this.init();
  }

  setOptions() {
    if ('split' in this.element.dataset) {
      this.options.breakpoints = {
        768: {
          slidesPerView: 3,
        },

        0:{
          slidesPerView:1,
        },
      };
    }

    if ('autoplay' in this.element.dataset) {
      this.options.autoplay = {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }

    if ('direction' in this.element.dataset) {
      this.options.direction = this.element.dataset.direction;
    }

    if ('clickable' in this.element.dataset) {
      this.options.pagination.clickable = true;
    }

    if ('slides' in this.element.dataset) {
      this.options.slidesPerView = Number(this.element.dataset.slides);
    }

    if ('space' in this.element.dataset) {
      this.options.spaceBetween = Number(this.element.dataset.space);
    }
  }

  init() {
    this.setOptions();
    //console.log(this.options);
    const swiper = new Swiper(this.element, this.options);
  }
}
